import styled from "styled-components";

interface CanvasLabelProps {
  visible: boolean;
}

const CanvasLabel = styled.div<CanvasLabelProps>`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: absolute;
  left: 8px;
  top: 10px;
  border-radius: ${({ theme }) => theme.borderRadiusDisclaimer};
  background-color: ${({ theme }) => theme.colors.baseWhite};
  color: ${({ theme }) => theme.colors.primary2};
  padding: 8px 16px;

  @media all and (max-width: ${({ theme }) => theme.mobileBreakingPoint}) {
    display: none;
  }
`;

export default CanvasLabel;
